
import { Vue } from "vue-class-component";

export default class BulkUpload extends Vue {}
